export const setTableInfo = (tableInfo) => ({
    type: 'SET_TABLE_INFO',
    payload: tableInfo,
});

export const showLoader = (IsShow) => ({
    type: 'SHOW_LOADER',
    payload: IsShow,
});

export const showProdAddedSuccessPopup = (IsProductAdded, addedProductName) => ({
    type: 'PRODUCT_ADDED_SUCCESS',
    payload: { IsProductAdded, addedProductName },
});

export const incrementCartCount = () => ({
    type: 'INCREMENT_CART_COUNT'
})

export const decrementCartCount = () => ({
    type: 'DECREMENT_CART_COUNT'
})

export const productCartCount = (productCount = 0) => ({
    type: 'PRODUCT_CART_COUNT',
    payload: productCount,
})

  